export default __webpack_public_path__ + "static/media/File_dock_light.493a5fe5.svg";